import { apiClient } from './api';
import { MyWorkService } from './MyWorkServiceBase';
export * from './MyWorkServiceBase';
/** Web My Work service singleton (cookie-auth web client). */
let _webMyWorkService = null;
function getWebMyWorkService() {
    if (!_webMyWorkService) {
        _webMyWorkService = new MyWorkService(apiClient);
    }
    return _webMyWorkService;
}
export const myWorkService = getWebMyWorkService();
